export const tokens = {
  colors: {
    bg: '#0A0A0A',
    bgCard: '#1A1A1A',
    bgCardHover: '#242424',
    bgChip: '#2A2A2A',
    bgChipActive: '#FFFFFF',
    text: '#FFFFFF',
    textSecondary: '#888888',
    textMuted: '#555555',
    accent: '#3081f6',
    accentHover: '#1a6de0',
    danger: '#E85D4A',
    dangerHover: '#D44A37',
    badge: '#3081f6',
    badgeBg: 'rgba(48,129,246,0.85)',
    cartBg: '#FF5722',
    cartBgActive: '#7A4F1E',
    border: '#2A2A2A',
    overlay: 'rgba(0,0,0,0.6)',
  },
  font: {
    family: "-apple-system, 'SF Pro Display', 'Helvetica Neue', sans-serif",
    sizes: {
      xs: '11px', sm: '13px', md: '15px',
      lg: '17px', xl: '22px', xxl: '28px', hero: '36px',
    },
    weights: { regular: 400, medium: 500, semibold: 600, bold: 700, black: 900 },
  },
  radius: {
    sm: '10px', md: '14px', lg: '18px',
    xl: '24px', full: '100px',
  },
  spacing: { xs: '4px', sm: '8px', md: '12px', lg: '16px', xl: '24px', xxl: '32px' },
  transition: {
    fast: '0.15s ease',
    normal: '0.25s ease',
    spring: '0.3s cubic-bezier(0.34, 1.56, 0.64, 1)',
  },
};
